import React, { useEffect, useState } from "react";
import { Row, Col, Spin } from "antd";
import styled from "styled-components";
import PerformanceMatrix from "../PerformanceMnagement/Viewperformance/PerformanceMatrix";
import { CALL_API } from "common/API";
import { useSelector } from "react-redux";
import { getUserInfo } from "redux/selectors";

const Customstyle = styled.div`
  .title {
    color: #636980;
  }
  .rows {
    display: flex;
    justify-content: space-between;
  }
  .col-label {
    color: #636980;
  }
  .col-value {
    margin-left: 40px;
    width: 98px;
    height: 18px;
    gap: 0px;
    opacity: 0px;
  }
  .text {
    font-size: 16px;
    font-weight: 400;
  }
  .footer {
    position: fixed;
    bottom: 0;
    right: 0;
    width: 78%;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 12px 54px;
    background: white;
    box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.1);
  }
  .footer-button {
    width: 100px;
    height: 35px;
    font-size: 16px;
    border-radius: 8px;
  }
  .parent-container {
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }
  .averagescore {
    width: 200px;
    height: 35px;
    border-radius: 8px;
    padding-right: 10px;
    padding-top: 5px;
    color: #636980;
    background-color: #f4f4f4;
    display: flex;
    justify-content: flex-end;
  }
  .score {
    font-weight: 500;
  }
  .matrixright {
    margin-top: 5px;
    font-size: 14px;
    font-weight: 400px;
    color: #636980;
    line-height: 10.26px;
    padding-top: 20px;
  }
  .recommendtext {
    color: #636980;
  }
  .count {
    color: black;
  }
  .appraiser {
    display: flex;
    gap: 300px;
  }
  .final {
    margin-top: -5px;
  }

  /* Matrix wrapper: just a clean container, sizing handled inside PerformanceMatrix */
  .matrix-wrapper {
    width: 100%;
  }
`;

function DashboardMatrix() {
  const userInfo = useSelector(getUserInfo);

  const [chartData, setChartData] = useState({});
  const [loading, setLoading] = useState(false);

  const getChartData = async (userId) => {
    try {
      const { performanceContractList, code } = await CALL_API(
        `/appraisal/appraiseemine?userid=${userId}`,
        "get"
      );

      if (code === "SUCCESS") {
        const filterd = performanceContractList
          ?.filter(
            (item) =>
              item.apraiseemailid === userId &&
              item.contractstatus === "reviewed"
          )
          ?.sort((a, b) => b.contractid - a.contractid);

        const validTechnicalScores = filterd
          ?.map((item) => Number(item.averagetechnicalscore))
          ?.filter((score) => !isNaN(score));

        const averageTechnicalScore =
          validTechnicalScores?.length > 0
            ? validTechnicalScores.reduce((sum, score) => sum + score, 0) /
            validTechnicalScores.length
            : 0;

        const averageSoftScoreForPrimary =
          filterd?.find((item) => item.roletype === "Primary")
            ?.averagesoftscore || 0;

        if (filterd?.length > 0) {
          setChartData({
            xvalue: averageSoftScoreForPrimary,
            yvalue: averageTechnicalScore,
          });
        } else {
          setChartData({});
        }
      }
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    if (userInfo?.userid) {
      getChartData(userInfo.userid);
    }
  }, [userInfo?.userid]);

  return (
    <Customstyle>
      <div className="d-flex justify-content-between align-items-center">
        <h6>My Performance</h6>
        <div className="d-flex gap-3">
          <span>
            Technical Skill:{" "}
            {isNaN(Number(chartData?.yvalue))
              ? "0"
              : Number(chartData?.yvalue)?.toFixed(2)}
          </span>
          <span>
            Soft Skill:{" "}
            {isNaN(Number(chartData?.xvalue))
              ? "0"
              : Number(chartData?.xvalue)?.toFixed(2)}
          </span>
        </div>
      </div>

      <br />

      <Row gutter={24} style={{ marginBottom: "50px" }}>
        <Col xs={24}>
          <Spin spinning={loading}>
            {/* 
              Removed the fixed .matrix height class and ResponsiveContainer.
              .matrix-wrapper constrains to card width and clips overflow.
              PerformanceMatrix receives width="100%" so it fills the space.
            */}
            <div className="matrix-wrapper" style={{ height: "300px" }}>
              <PerformanceMatrix
                matrixdetails={false}
                Xaxis={chartData?.xvalue || 0}
                Yaxis={chartData?.yvalue?.toFixed(2) || 0}
                width="100%"
              />
            </div>
          </Spin>
        </Col>
      </Row>
    </Customstyle>
  );
}

export default DashboardMatrix;